var _pattern, _rect;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _pattern || (_pattern = /*#__PURE__*/React.createElement("pattern", {
    id: "bg_svg__a",
    width: 15,
    height: 15,
    x: 0,
    y: 0,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.4,
    cy: 0.4,
    r: 0.4,
    fill: "#81818a"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "url(#bg_svg__a)"
  })));
}

export default __webpack_public_path__ + "./fonts/bg.5849be47d62acc3c6e023597df89919e.svg";
export { SvgBg as ReactComponent };